module.exports = __webpack_public_path__ + "static/media/Screenshot_5.e5aa9ce9.png";